export default __webpack_public_path__ + "static/media/shape.99fbbe06.svg";